module.exports = __webpack_public_path__ + "static/media/xe.f3a04ff4.mp3";